export default __webpack_public_path__ + "static/media/scuderia.75a6a55b.png";